<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">Статистика</h1>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs12 lg12 md12>

        <p class="title">Статистика по брендам</p>
        <v-layout class="elevation-1 white mb-4 pa-3 column">
          <v-flex xs12 lg12 md12>
            <v-layout>
              <v-flex xs4 lg4 md4>
                <v-menu
                    ref="productBrandStatisticsStartDateMenu"
                    :close-on-content-click="false"
                    v-model="productBrandStatistics.startDateMenu"
                    :return-value.sync="productBrandStatistics.startDate"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    class="mr-3"
                >
                  <v-text-field
                      slot="activator"
                      v-model="productBrandStatistics.startDateFormatted"
                      label="Начальная дата"
                      readonly
                      outline
                  ></v-text-field>
                  <v-date-picker
                      v-model="productBrandStatistics.startDate"
                      locale="ru"
                      :first-day-of-week="1"
                      @input="onInputStartDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs4 lg4 md4>
                <v-menu
                    ref="productBrandStatisticsEndDateMenu"
                    :close-on-content-click="false"
                    v-model="productBrandStatistics.endDateMenu"
                    :return-value.sync="productBrandStatistics.endDate"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    class="mr-3"
                >
                  <v-text-field
                      slot="activator"
                      v-model="productBrandStatistics.endDateFormatted"
                      label="Конечная дата"
                      readonly
                      outline
                  ></v-text-field>
                  <v-date-picker
                      v-model="productBrandStatistics.endDate"
                      locale="ru"
                      :first-day-of-week="1"
                      @input="onInputEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs4 lg4 md4>
                <v-select
                    :items="groupList"
                    label="Группировка"
                    outline
                    v-model="productBrandStatistics.group"
                    @input="getProductBrandChartData"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 lg12 md12>
            <v-layout>
              <v-flex xs12 lg12 md12>
                <v-select
                    v-model="productBrandStatistics.distributionChannelIdList"
                    :items="distributionChannelList"
                    item-text="title"
                    item-value="id"
                    chips
                    label="Каналы продаж"
                    multiple
                    outline
                    @input="getProductBrandChartData"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 lg12 md12>
            <v-layout row>
              <v-flex xs12 lg12 md12>
                <v-combobox
                    :items="[]"
                    v-model="productBrandStatistics.branchesSelected"
                    label="Филиалы"
                    chips
                    outline
                    multiple
                    readonly
                    @click="productBrandStatistics.branchesDialog = true"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                        @click="productBrandStatistics.branchesDialog = true"
                    >
                      <strong>{{ data.item }}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 lg12 md12>
            <v-layout>
              <v-flex xs12 lg12 md12>
                <v-combobox
                    v-model="productBrandStatistics.productItems"
                    :items="[]"
                    label="Категории"
                    chips
                    outline
                    multiple
                    readonly
                    @click="productBrandStatistics.productDialog = true"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                        :selected="data.selected"
                        @click="productBrandStatistics.productDialog = true"
                    >
                      <strong>{{ data.item.title }}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 lg12 md12 class="mt-3">
            <v-layout>
              <v-flex xs12 lg12 md12>
                <line-chart :data="productBrandStatistics.chartData" :library="chartOptions"></line-chart>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-dialog
              v-model="productBrandStatistics.branchesDialog"
              max-width="600"
          >
            <v-card>
              <v-card-title class="headline">Филиалы</v-card-title>
              <v-layout row>
                <v-flex xs12 lg12 md12 class="ml-2">
                  <div
                      v-for="(branch, index) in productBrandStatistics.branches"
                      :key="branch.id"
                  >
                    <v-checkbox
                        :label="branch.title"
                        class="ma-0 pa-0"
                        v-model="productBrandStatistics.branches[index].checked"
                        @change="onBranchInput"
                    ></v-checkbox>
                  </div>
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="productBrandStatistics.branchesDialog = false">ОК</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
              v-model="productBrandStatistics.productDialog"
              max-width="600"
          >
            <v-card>
              <v-card-title class="headline">Категории</v-card-title>
              <v-layout row v-if="productBrandStatistics.productTreeData.length > 0">
                <v-flex xs12 lg12 md12 class="ml-2">
                  <tree
                      ref="productBrandStatisticsTree"
                      :data="productBrandStatistics.productTreeData"
                      :options="{
                      checkbox: true,
                        fetchData(node) {
                          if (node.data.type === 'category') {
                            return getProductBrand(node.data.id)
                          } else if (node.data.type === 'brand') {
                            return getProductSku(node.data.id)
                          }
                        }
                      }"
                      class="tree--small"
                      @node:checked="productItemsUpdate"
                      @node:unchecked="productItemsUpdate"
                  />
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="productBrandStatistics.productDialog = false">ОК</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Статистика'}
        ],
        pageDataReady: {
          isReady: false
        },
        groupList: [{text: 'День', value: 'day'}, {text: 'Неделя', value: 'week'}, {text: 'Месяц', value: 'month'}],
        channelList: [],
        productTreeIdCounter: 0,
        productBrandStatistics: {
          startDate: null,
          startDateFormatted: null,
          startDateMenu: false,
          endDate: null,
          endDateFormatted: null,
          endDateMenu: false,
          group: 'day',
          distributionChannelIdList: [],
          productDialog: false,
          productCategoryIdList: [],
          productBrandIdList: [],
          productSkuList: [],
          productTreeData: [],
          productItems: [],
          chartData: [],
          branches: [],
          branchesSelected: [],
          branchesDialog: false
        },
        chartOptions: {
          tooltips: {
            mode: 'index',
            displayColors: true,
            callbacks: {
              label: function (tooltipItem) {
                let val = tooltipItem.yLabel
                val = Math.round(parseFloat(val)).toString()
                let result = ''
                let i = 0
                val.split('').reverse().forEach(function (char) {
                  if (i === 3) {
                    result += ' '
                    i = 1
                  } else {
                    i++
                  }
                  result += char
                })
                result = result.split('').reverse().join('')
                return result + ' ₽'
              }
            }
          }
        }
      }
    },
    beforeCreate () {
      this.$store.commit('setPageLoading', true)
    },
    created () {
      this.pageDataStatus()
      this.$store.commit('setPageTitle', 'Статистика по брендам')
      this.$store.dispatch('getDistributionChannelList')
      this.getProductCategory('productBrandStatistics')
        .then((data) => {
          this.productBrandStatistics.productTreeData = data
        })
        .catch((e) => {
          console.log(e)
        })

      let date = new Date()
      this.productBrandStatistics.endDate = this.$moment(date).format('YYYY-MM-DD')
      date.setDate(date.getDate() - 30)
      this.productBrandStatistics.startDate = this.$moment(date).format('YYYY-MM-DD')
      this.productBrandStatistics.startDateFormatted = this.formatDate(this.productBrandStatistics.startDate)
      this.productBrandStatistics.endDateFormatted = this.formatDate(this.productBrandStatistics.endDate)
      this.getProductBrandChartData()

      this.$store.dispatch('getBranchList')
    },
    computed: {
      distributionChannelList () {
        return this.$store.getters.distributionChannelList
      },
      productBrandChartData () {
        return this.$store.getters.productBrandChartData
      },
      productBrandStatisticsProductDialog () {
        return this.productBrandStatistics.productDialog
      },
      branchList () {
        return this.$store.getters.branchList
      }
    },
    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}.${month}.${year}`
      },
      pageDataStatus () {
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      getProductBrandChartData () {
        let filtersData = {
          start_date: this.productBrandStatistics.startDate,
          end_date: this.productBrandStatistics.endDate,
          group: this.productBrandStatistics.group
        }

        if (this.productBrandStatistics.distributionChannelIdList.length > 0) {
          filtersData.distribution_channel_id_list = this.productBrandStatistics.distributionChannelIdList
        }

        if (this.productBrandStatistics.productCategoryIdList.length > 0 || this.productBrandStatistics.productBrandIdList.length > 0 || this.productBrandStatistics.productSkuList.length > 0) {
          this.filterChildrenProductIdList(this.$refs.productBrandStatisticsTree.model, this.productBrandStatistics)
          if (this.productBrandStatistics.productCategoryIdList.length > 0) {
            filtersData.product_category_id_list = this.productBrandStatistics.productCategoryIdList
          }
          if (this.productBrandStatistics.productBrandIdList.length > 0) {
            filtersData.product_brand_id_list = this.productBrandStatistics.productBrandIdList
          }
          if (this.productBrandStatistics.productSkuList.length > 0) {
            filtersData.product_sku_id_list = this.productBrandStatistics.productSkuList
          }
        }

        let branchIdList = []
        for (let i = 0; i < this.productBrandStatistics.branches.length; i++) {
          if (this.productBrandStatistics.branches[i].checked) {
            branchIdList.push(this.productBrandStatistics.branches[i].id)
          }
        }
        if (branchIdList.length > 0) {
          filtersData.branch_id_list = branchIdList
        }

        this.$store.dispatch('productBrandChartData', filtersData)
      },
      onInputStartDate () {
        this.$refs.productBrandStatisticsStartDateMenu.save(this.productBrandStatistics.startDate)
        this.productBrandStatistics.startDateFormatted = this.formatDate(this.productBrandStatistics.startDate)
        this.getProductBrandChartData()
      },
      onInputEndDate () {
        this.$refs.productBrandStatisticsEndDateMenu.save(this.productBrandStatistics.endDate)
        this.productBrandStatistics.endDateFormatted = this.formatDate(this.productBrandStatistics.endDate)
        this.getProductBrandChartData()
      },
      onBranchInput () {
        this.productBrandStatistics.branchesSelected = []
        for (let i = 0; i < this.productBrandStatistics.branches.length; i++) {
          if (this.productBrandStatistics.branches[i].checked) {
            this.productBrandStatistics.branchesSelected.push(this.productBrandStatistics.branches[i].title)
          }
        }
        this.getProductBrandChartData()
      },
      productItemsUpdate () {
        this.productBrandStatistics.productItems = []
        this.productBrandStatistics.productCategoryIdList = []
        let tree = this.$refs.productBrandStatisticsTree.model
        for (let i = 0; i < tree.length; i++) {
          if (tree[i].states.checked) {
            this.productBrandStatistics.productItems.push({title: tree[i].data.text, color: 'blue lighten-3', id: tree[i].data.id, type: tree[i].data.type})
            this.productBrandStatistics.productCategoryIdList.push(tree[i].data.id)
          } else {
            for (let k = 0; k < tree[i].children.length; k++) {
              if (tree[i].children[k].states.checked) {
                this.productBrandStatistics.productItems.push({title: tree[i].children[k].data.text, color: 'green lighten-3', id: tree[i].children[k].data.id, type: tree[i].children[k].data.type})
                this.productBrandStatistics.productBrandIdList.push(tree[i].children[k].data.id)
              } else {
                for (let j = 0; j < tree[i].children[k].children.length; j++) {
                  if (tree[i].children[k].children[j].states.checked) {
                    this.productBrandStatistics.productItems.push({title: tree[i].children[k].children[j].data.text, color: 'orange lighten-3', id: tree[i].children[k].children[j].data.id, type: tree[i].children[k].children[j].data.type})
                    this.productBrandStatistics.productSkuList.push(tree[i].children[k].children[j].data.id)
                  }
                }
              }
            }
          }
        }
      },
      async getProductCategory () {
        let categoryList = []
        await this.$store.dispatch('getProductCategoryList')
          .then((data) => {
            for (let i = 0; i < data.product_category_list.length; i++) {
              categoryList[i] = {
                text: data.product_category_list[i].title,
                data: {
                  id: data.product_category_list[i].id,
                  type: 'category'
                },
                id: this.productTreeIdCounter++,
                isBatch: false
              }
              categoryList[i].state = { checkbox: true }
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return categoryList
      },
      filterChildrenProductIdList (tree, statisticsObj) {
        for (let i = 0; i < tree.length; i++) {
          let brandDelete = false
          let categoryPosition = statisticsObj.productCategoryIdList.indexOf(tree[i].data.id)
          if (~categoryPosition) {
            brandDelete = true
          }
          for (let j = 0; j < tree[i].children.length; j++) {
            let skuDelete = false
            let brandPosition = statisticsObj.productBrandIdList.indexOf(tree[i].children[j].data.id)
            if (~brandPosition) {
              skuDelete = true
            }
            for (let k = 0; k < tree[i].children[j].children.length; k++) {
              let skuPosition = statisticsObj.productSkuList.indexOf(tree[i].children[j].children[k].data.id)
              if (skuDelete && ~skuPosition) {
                statisticsObj.productSkuList.splice(skuPosition, 1)
              }
            }
            if (brandDelete && ~brandPosition) {
              statisticsObj.productBrandIdList.splice(brandPosition, 1)
            }
          }
        }
      }
    },
    watch: {
      productBrandChartData (val) {
        this.productBrandStatistics.chartData = []
        for (let k = 0; k < this.productBrandChartData.length; k++) {
          let index = this.productBrandStatistics.chartData.length
          this.productBrandStatistics.chartData[index] = {data: {}, name: this.productBrandChartData[k].title}
          for (let i = 0; i < this.productBrandChartData[k].chart_series_value_list.length; i++) {
            this.productBrandStatistics.chartData[index].data[this.productBrandChartData[k].chart_series_value_list[i].date] = this.productBrandChartData[k].chart_series_value_list[i].value
          }
        }
      },
      productBrandStatisticsProductDialog (val) {
        if (!this.productBrandStatistics.productDialog) {
          this.getProductBrandChartData()
        }
      },
      branchList (val) {
        this.productBrandStatistics.branches = this.branchList
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Statistics/StatisticsProductBrand.vue